import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGarage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="garage"><path d="M21.25 19.25H2.75V8.91667L12 3.75L21.25 8.91667V19.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 15.25H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 19.25V11.25H6.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGarage;
